import React, { useState, useEffect } from "react";
import axios from "axios";
import Social from "./Social";

const InstaFeeds = ({ limit }) => {
    const [feeds, setFeedsData] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchInstagramPost() {
            try {
                const response = await axios.get(
                    `/.netlify/functions/instagram?limit=${limit}`,
                    { signal: abortController.signal }
                );

                console.log("API Response:", response.data);

                if (response.data && response.data.data) {
                    setFeedsData(response.data.data);
                } else {
                    console.log("No data in API response.");
                }
            } catch (err) {
                if (axios.isCancel(err)) {
                    console.log("Request canceled", err.message);
                } else {
                    console.error("Error fetching data:", err.response?.data || err.message);
                }
            }
        }

        fetchInstagramPost();

        return () => {
            abortController.abort();
        };
    }, [limit]);

    return <Social feeds={feeds} />;
};

export default InstaFeeds;
